// extracted by mini-css-extract-plugin
export var avatarContainer = "_5h-1";
export var largeAvatarContainer = "_5h-2";
export var smallAvatarContainer = "_5h-0";